module.exports = __webpack_public_path__ + "9fdc097b1e324976a7cfb1b344460fd8.pdf";